(() => {
  const readyAttr = 'data-doc-kicks-carousel-ready';

  function setupCarousel(scope = document) {
    const carousels = [];

    if (scope instanceof Element && scope.matches('.featured-carousel__slider')) {
      carousels.push(scope);
    }

    scope.querySelectorAll?.('.featured-carousel__slider').forEach((carousel) => carousels.push(carousel));

    carousels.forEach((carousel) => {
      if (carousel.hasAttribute(readyAttr)) return;

      const track = carousel.querySelector('.featured-carousel__track');
      const slides = Array.from(carousel.querySelectorAll('.featured-carousel__slide'));
      const previousButton = carousel.querySelector('.slider-button--prev');
      const nextButton = carousel.querySelector('.slider-button--next');
      const currentCounter = carousel.querySelector('.slider-counter--current');
      const totalCounter = carousel.querySelector('.slider-counter--total');

      if (!track || slides.length < 2 || !previousButton || !nextButton) return;

      carousel.setAttribute(readyAttr, 'true');
      track.style.overscrollBehaviorX = 'none';

      const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

      const getMaxScroll = () => Math.max(track.scrollWidth - track.clientWidth, 0);

      const getClampedScrollLeft = () => clamp(Number.isFinite(track.scrollLeft) ? track.scrollLeft : 0, 0, getMaxScroll());

      const syncScrollBounds = () => {
        const clamped = getClampedScrollLeft();

        if (Math.abs(track.scrollLeft - clamped) > 1) {
          track.scrollTo({ left: clamped, behavior: 'auto' });
        }

        return clamped;
      };

      const getStep = () => {
        const visibleSlides = slides.filter((slide) => slide.clientWidth > 0);
        if (visibleSlides.length < 2) return visibleSlides[0]?.clientWidth || track.clientWidth;

        return visibleSlides[1].offsetLeft - visibleSlides[0].offsetLeft || visibleSlides[0].clientWidth;
      };

      const getVisibleCount = () => {
        const step = Math.max(getStep(), 1);

        return Math.max(Math.round(track.clientWidth / step), 1);
      };

      const getPageStep = () => getStep() * getVisibleCount();

      const getPageTotal = () => {
        const maxScroll = Math.max(track.scrollWidth - track.clientWidth, 0);
        if (maxScroll <= 1) return 1;

        return Math.max(Math.ceil(slides.length / getVisibleCount()), 1);
      };

      const updateControls = () => {
        const maxScroll = Math.max(track.scrollWidth - track.clientWidth, 0);
        const pageStep = Math.max(getPageStep(), 1);
        const pageTotal = getPageTotal();
        const scrollLeft = syncScrollBounds();
        const currentPage = clamp(Math.round(scrollLeft / pageStep) + 1, 1, pageTotal);

        if (currentCounter) currentCounter.textContent = currentPage;
        if (totalCounter) totalCounter.textContent = pageTotal;

        carousel.classList.toggle('featured-carousel__slider--single-page', pageTotal < 2);
        previousButton.toggleAttribute('disabled', scrollLeft <= 1);
        nextButton.toggleAttribute('disabled', scrollLeft >= maxScroll - 1);
      };

      const scrollByPage = (direction) => {
        const current = syncScrollBounds();
        const maxScroll = getMaxScroll();
        if ((direction < 0 && current <= 1) || (direction > 0 && current >= maxScroll - 1)) {
          updateControls();
          return;
        }

        const target = clamp(current + getPageStep() * direction, 0, maxScroll);

        track.scrollTo({
          left: target,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });

        requestUpdate();
        window.setTimeout(requestUpdate, 360);
      };

      let queued = false;
      const requestUpdate = () => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(() => {
          queued = false;
          updateControls();
        });
      };

      previousButton.addEventListener('click', (event) => {
        event.preventDefault();
        scrollByPage(-1);
      });

      nextButton.addEventListener('click', (event) => {
        event.preventDefault();
        scrollByPage(1);
      });

      track.addEventListener(
        'scroll',
        () => {
          syncScrollBounds();
          requestUpdate();
        },
        { passive: true }
      );
      window.addEventListener('resize', requestUpdate);
      updateControls();
    });
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) setupCarousel(node);
      });
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setupCarousel();
      observer.observe(document.body, { childList: true, subtree: true });
    });
  } else {
    setupCarousel();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('shopify:section:load', (event) => setupCarousel(event.target));
})();
